export class SendTestProfile {
  constructor(
    public campaign_id?: number,
    public aep_test_profile?: boolean,
    public first_name?: string,
    public last_name?: string,
    public dob?: string,
    public gender?: string,
    public phone_with_countrycode?: string,
    public email?: string,
    public user_identifiers?: Object,
    public address_line1?: string,
    public address_line2?: string,
    public address_city?: string,
    public address_state?: string,
    public address_country?: string,
    public address_postalcode?: string,
    public client_id?: string,
    public aep_test_profile_environment?: string,
    public event_type?: string,
    public event_sub_type?: string,
  ) { }
}



// WEBPACK FOOTER //
// ./src/app/modules/send-test-profile/send-test-profile.model.ts